// What a customer wrote of their samples in the laboratory's sample submission form, as our pages
// show it: only the columns a list of samples has something in, and a choice of a list by its
// label (it is kept by its code).
export const filledColumns = (columns, samples) => columns.filter((column) => samples.some((sample) => (sample.answers ?? {})[column.code] !== undefined));

export function answerText(column, value) {
  if (value === undefined || value === null) return '';
  if (column.type === 'option') return column.options?.find((option) => option.code === value)?.label ?? String(value);
  return String(value);
}

// The form's eighteen columns are too many to read side by side, so a table of samples shows them in
// a few groups that belong together, each its first column's answer with the others' under it: the
// container (its type, then its name and well), what the sample is (tissue or cell type, organism),
// the application, the amount, the concentration (with the instrument and the buffer under it), its
// quality (integrity, then the two purity ratios), and the temperatures. A number carries its unit
// (amount and its unit are one cell). A column of no group is a group of its own, so a column added
// to a form later still shows.
const GROUPS = [
  ['container_type', 'container_name', 'well_location'],
  ['tissue_cell_type', 'organism'],
  ['application'],
  ['amount'],
  ['concentration', 'concentration_instrument', 'buffer'],
  ['integrity', 'a260_280', 'a260_230'],
  ['shipped_temperature', 'storage_temperature'],
  ['remarks'],
];

// The groups a list of samples has something in, each with its filled columns in order. A unit's
// column (amount_unit) goes with its number and is not a column of its own.
export function answerGroups(columns, samples) {
  const filled = filledColumns(columns, samples).filter((column) => !column.unitOf);
  const used = new Set();
  const groups = [];
  for (const codes of GROUPS) {
    const members = codes.map((code) => filled.find((column) => column.code === code)).filter(Boolean);
    members.forEach((column) => used.add(column.code));
    if (members.length > 0) groups.push(members);
  }
  for (const column of filled) if (!used.has(column.code)) groups.push([column]);
  return groups;
}

// One column's answer with its unit, if it has one: "30 µL".
export function answerWithUnit(columns, column, answers) {
  const value = answerText(column, (answers ?? {})[column.code]);
  if (value === '') return '';
  const unit = columns.find((entry) => entry.unitOf === column.code);
  const unitText = unit ? answerText(unit, (answers ?? {})[unit.code]) : '';
  return unitText ? `${value} ${unitText}` : value;
}
